import {
  FETCH_CONFIGURATOR_PAGE_FIELDS,
  TOGGLE_MAIN_RING_MODAL,
  TOGGLE_HOLDER_RING_MODAL,
  CLOSE_MODALS,
} from "../actions/types";

const INITIAL_STATE = {
  pageTitleText: "",
  selectRingButtonText: "",
  selectRingImageURL: "",
  selectHolderRingButtonText: "",
  selectHolderRingImageURL: "",
  ringsChosenText: "",
  diamondSizeText: "",
  priceText: "",
  backButtonText: "",
  forwardButtonText: "",
  ringOverlayTitleText: "",
  ringOverlayCollectionTitleText: "",
  holderRingOverlayTitleText: "",
  holderRingOverlayCollectionTitleText: "",
  defaultRingDiamondSize: "",
  modalMainRingOpen: false,
  modalHolderRingOpen: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_CONFIGURATOR_PAGE_FIELDS:
      return {
        ...state,
        pageTitleText: action.payload.items[0].fields.pageTitleText,
        selectRingButtonText:
          action.payload.items[0].fields.selectRingButtonText,
        selectRingImageURL: action.payload.items[0].fields.selectRingImageURL,
        selectHolderRingButtonText:
          action.payload.items[0].fields.selectHolderRingButtonText,
        selectHolderRingImageURL:
          action.payload.items[0].fields.selectHolderRingImageURL,
        ringsChosenText: action.payload.items[0].fields.ringsChosenText,
        diamondSizeText: action.payload.items[0].fields.diamondSizeText,
        priceText: action.payload.items[0].fields.priceText,
        backButtonText: action.payload.items[0].fields.backButtonText,
        forwardButtonText: action.payload.items[0].fields.forwardButtonText,
        ringOverlayTitleText:
          action.payload.items[0].fields.ringOverlayTitleText,
        ringOverlayCollectionTitleText:
          action.payload.items[0].fields.ringOverlayCollectionTitleText,
        holderRingOverlayTitleText:
          action.payload.items[0].fields.holderRingOverlayTitleText,
        holderRingOverlayCollectionTitleText:
          action.payload.items[0].fields.holderRingOverlayCollectionTitleText,
        defaultRingDiamondSize:
          action.payload.items[0].fields.defaultRingDiamondSize,
      };
    case TOGGLE_MAIN_RING_MODAL:
      return {
        ...state,
        modalMainRingOpen: !state.modalMainRingOpen,
        modalHolderRingOpen: false,
      };
    case TOGGLE_HOLDER_RING_MODAL:
      return {
        ...state,
        modalHolderRingOpen: !state.modalHolderRingOpen,
        modalMainRingOpen: false,
      };
    case CLOSE_MODALS:
      return {
        ...state,
        modalMainRingOpen: false,
        modalHolderRingOpen: false,
      };
    default:
      return state;
  }
};
